/* eslint-disable react/prop-types */
import React, { Component, useEffect, useState } from "react";
import Select from "react-select";
import "bootstrap/dist/css/bootstrap.min.css";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import axios from "axios";

import "./NewAddCourseMaster.css";
import { useHistory } from "react-router-dom";

import Modal from "react-awesome-modal";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import FormControl from "@material-ui/core/FormControl";
import CustomInput from "components/CustomInput/CustomInput";
import Button from "components/CustomButtons/Button";
import Constants from "variables/Constants";
import Grid from "@material-ui/core/Grid";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { MultiSelect } from "react-multi-select-component";

// import editorConfiguration from "../variables/EditorConfiguration";
//import styles from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";
// import { MultiSelect } from "react-multi-select-component";
// Inside src/index.js or src/App.js

let ProgressBar = (props) => {
  return (
    <div className="progress-bar">
      <Filler percentage={props.percentage} />
    </div>
  );
};
let Filler = (props) => {
  return (
    <div className="filler" style={{ width: `${props.percentage}%` }}></div>
  );
};
let fd = new FormData();
const facultyIds = [];

const UpdateNewCourseMaster = ({ match, courseId }) => {
  const location = useLocation();

  const categoryData = location.state?.categoryData;

  console.log("Course Details LINKS", categoryData);

  const [category, setCategory] = useState("");
  const [title, setTitle] = useState("");
  const [sku, setSku] = useState("");
  const [duration, setDuration] = useState("");
  const [faculty, setFaculty] = useState([]);
  const [facultyWithName, setFacultyWithName] = useState("");
  const [vendorCommission, setVendorCommission] = useState(0);
  const [facultyCommission, setFacultyCommission] = useState(0);
  const [facultyId, setFacultyId] = useState("");
  const [facultyArr, setFacultyArr] = useState([]);
  const [levels, setLevels] = useState([]);
  const [cod, setCod] = useState("");
  const [akshare, setAkshare] = useState(100);
  const [facultyshare, setFacultyshare] = useState("");
  const [proDesc, setProDesc] = useState("");
  const [courseDetails, setCourseDetails] = useState("");
  const [specification, setSpecification] = useState("");
  const [productId, setProductId] = useState("");
  const [googlesheetdetails, setGooglesheetdetails] = useState("");
  const [index, setIndex] = useState([]);
  const [img, setImg] = useState([]);
  const [confirmation, setConfirmation] = useState(["Yes", "No"]);
  const [confirm, setConfirm] = useState("No");
  const [testSeries, setTestSeries] = useState([]);
  const [test, setTest] = useState([]);
  const [thumb, setThumb] = useState([]);
  const [cashback, setCashback] = useState("");
  const [discount, setDiscount] = useState("");
  const [gcLink, setGcLink] = useState("");
  const [gwLink, setGwLink] = useState("");
  const [gaLink, setGaLink] = useState("");
  const [demoLink1, setDemoLink1] = useState("");
  const [demoLink2, setDemoLink2] = useState("");
  const [demoLink3, setDemoLink3] = useState("");
  const [demoLink4, setDemoLink4] = useState("");
  const [offValue, setOffValue] = useState("");
  const [subject, setSubject] = useState("");
  const [offType, setOffType] = useState("");
  const [payment_gateway, setPayment_gateway] = useState("");
  const [offTypeArray, setOffTypeArray] = useState(["percent", "amount"]);
  const [paymentGatewayArray, setPaymentGatewayArray] = useState([
    "razorpay",
    "phonepe",
  ]);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const [courses, setCourses] = useState([]);
  const [attempts, setAttempts] = useState([]);
  const [batches, setBatches] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [redirect, setRedirect] = useState(false);
  const [atLeast, setAtLeast] = useState(false);
  const [notification, setNotification] = useState(false);
  const [displayVariant, setDisplayVariant] = useState(false);
  const [gatewayAlert, setGatewayAlert] = useState(false);
  const [aAlert, setAAlert] = useState(false);
  const [bAlert, setBAlert] = useState(false);
  const [cAlert, setCAlert] = useState(false);
  const [dAlert, setDAlert] = useState(false);
  const [visible, setVisible] = useState(false);
  const [eAlert, setEAlert] = useState(false);
  const [fAlert, setFAlert] = useState(false);
  const [TestSeriesAlert, setTestSeriesAlert] = useState(false);
  const [langAlert, setLangAlert] = useState(false);
  const [loading, setLoading] = useState(false);
  const [batchAlert, setBatchAlert] = useState(false);
  const [languages, setLanguages] = useState(["Hindi", "English"]);
  const [language, setLanguage] = useState("");
  const [dropShow, setDropShow] = useState(false);
  const [type, setType] = useState(["Normal", "Combo"]);
  const [combo_type, setCombo_type] = useState("");
  const [batch, setBatch] = useState([]);
  const [batchwings, setBatchwings] = useState("");
  const [batch_wings, setBatch_wings] = useState([]);
  const [batch_id, setBatch_id] = useState([]);
  const [attempt, setAttempt] = useState("");
  const [getSubjectFilter, setGetSubjectFilter] = useState([]);
  const [level, setLevel] = useState("");
  const [streams, setStreams] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("");
  const [subjectFilterOptions, setSubjectFilterOptions] = useState([]);
  const [subject_filter_id, setSubject_filter_id] = useState(0);
  const [imgPreview, setImgPreview] = useState(null);

  const [test_seriesId, setTest_seriesId] = useState([]);
  const [amenities, setAmenities] = useState([]);
  const [selected_amenities, setSelected_amenities] = useState([]);
  const [errors, setErrors] = useState({});

  const [amenity_id_array, setAmenity_id_array] = useState([]);
  const [ordermailtemplate, setOrdermailtemplate] = useState("");
  const [shippingmailtemplate, setShippingmailtemplate] = useState("");
  const [orderTemplates, setOrderTemplates] = useState([]);
  const [shippingTemplates, setShippingTemplates] = useState([]);
  const [submittedData, setSubmittedData] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [secondFormEntries, setSecondFormEntries] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [requiredFields, setRequiredFields] = useState(false);
  const [editVariantId, setEditVariantId] = useState(null);
  const [variantArray, setVariantArray] = useState([]);
  const [variants, setVariants] = useState([]);
  const [testSeriesOptions, setTestSeriesOptions] = useState([]);
  const [templateOptions, setTemplateOptions] = useState([]);
  const [shippingTemplateOptions, setShippingTemplateOptions] = useState([]);
  const [attemptOptions, setAttemptOptions] = useState([]);
  const [isPrefilled, setIsPrefilled] = useState(false); // 💡 added
  const [addedBatches, setAddedBatches] = useState([]); // To store selected batches
  const [notAddedBatches, setNotAddedBatches] = useState([]); // To store unselected batches
  const [hasUserChangedTestSeries, setHasUserChangedTestSeries] = useState(
    false,
  );

  const [facultyIds, setFacultyIds] = useState([]);

  const { id } = match.params; // Get the course ID from the URL
  const [formData, setFormData] = useState({
    combo_type: "",
    subjects: [],
    subjectFilters: [],
    attempt: "",
    batchwings: "",
    batch: [],
    sku: "",
    title: "",
    duration: "",
    akshare: "",
    payment_gateway: "",
    ordermailtemplate: null,
    shippingmailtemplate: null,
    language: "",
    testSeries: "",
    selectedSeriesId: "",
    short_description: "",
    includeTestSeries: "", // this is the ID like "3"
    selectedSeriesId: "", // for dropdown batch selection
    showTestSeries: "No", // controls Yes/No dropdown

    cashback: "",
    demoLink1: "",
    googlesheetdetails: "",
    demoLink1: "",
    demoLink2: "",
    demoLink3: "",
    demoLink4: "",
    discount: "",
    value: "",
    offer_type: "",
    img: "",
    faculty: [],
    facultyWithName: "",
    vendorCommission: 0,
    facultyCommission: 0,
    facultyId: "",
    facultyArr: [],
    facultyshare: "",
    apple_product_id: "",
    apple_id: "",
    selectedColor: "",
    amenitiesIds: [],
    amenitiesDetails: [],
  });

  const [secondFormData, setSecondFormData] = useState({
    attempt_id: "",
    price: "",
    sku: "",
  });

  useEffect(() => {
    fetchData();
    //fetchBatches();
    fetchBatches1();
  }, []);

  const fetchData = async () => {
    try {
      setOrderTemplates([]);
      setShippingTemplates([]);

      const [orderRes, shippingRes] = await Promise.all([
        axios.get(`${Constants.getUrls.getmailTemplate}?type=Order`),
        axios.get(`${Constants.getUrls.getmailTemplate}?type=Shipping`),
      ]);

      console.log("Order Res", orderRes.data.data);
      console.log("Shipping Res", shippingRes.data.data);

      setOrderTemplates(orderRes.data.data);
      setShippingTemplates(shippingRes.data.data);

      const coursesRes = await axios.get(
        "https://admin.akclasses.in/api/courseCategoriesR",
      );
      console.log("Course Data", coursesRes.data);
      setCourses(coursesRes.data);

      const amenitiesRes = await axios.get(
        `${Constants.getUrls.getAmenities}?per_page=150`,
      );
      console.log("Amenities", amenitiesRes.data.data);

      setAmenities(amenitiesRes.data.data);
      const array_id = JSON.parse(categoryData.amenity_ids || "[]");

      const selected = amenitiesRes.data.data
        .filter((item) => array_id.includes(item.id))
        .map((item) => ({
          label: item.title,
          value: item.id,
        }));

      setSelected_amenities(selected);

      // const amenitiesData = amenitiesRes.data.data.map((val) => ({
      //   label: val?.title,
      //   value: val?.id,
      // }));

      const testSeriesRes = await axios.get(
        "https://admin.akclasses.in/api/courses?type=Test_Series&per_page=10",
      );
      console.log("Series", testSeriesRes.data.data);

      const testSeriesData = testSeriesRes.data.data.map((val) => ({
        label: val?.TITLE,
        value: val?.ID,
      }));
      setTestSeries(testSeriesData);

      const facultyRes = await axios.get(
        "https://admin.akclasses.in/api/facultyR",
      );
      console.log("Faculty", facultyRes.data);
      setFacultyArr(facultyRes.data);

      // If you want to enable batchWings API later
      const batchwings = await axios.get(
        "https://admin.akclasses.in/api/batchWings?per_page=10&is_deleted=0",
      );
      console.log(batchwings);
      setBatchwings(batchwings.data.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleBatch = (e) => {
    setBatch(e.target.value);
  };

  // const handleFile = (e) => {
  //   const { name, files } = e.target;

  //   if (name === "img") {
  //     setImg(files[0]);
  //   } else if (name === "codPdf") {
  //     setCodPdf(files[0]);
  //   }
  //   // add more conditions if other file inputs exist
  // };

  const openModal = () => {
    setVisible(true);
  };

  const closeModal = () => {
    setVisible(false);
  };

  const handleAttempt = (e) => {
    const selectedValue = e.target.value;
    setAttempt(selectedValue); // If you're still using this state
    setFormData((prev) => ({
      ...prev,
      attempt: selectedValue, // ✅ update formData
    }));
    setAAlert(false);
  };

  const handleLevel = async (e) => {
    const { name, value } = e.target;

    if (name === "category") {
      setCategory(value);
    }

    setAAlert(false);

    try {
      const resp = await axios.get(
        `https://admin.akclasses.in/api/showCategory_with_level/${value}`,
      );
      console.log("Level Data", resp.data);
      setLevels(resp.data.level);
    } catch (error) {
      console.error("Error fetching levels:", error);
    }
  };

  const handleStream = async (e) => {
    const { name, value } = e.target;
    setCAlert(false);
    setLevel(value);

    try {
      const { data } = await axios.get(
        `https://admin.akclasses.in/api/level/${value}`,
      );
      setStreams(data.stream);
    } catch (error) {
      console.error("Error fetching streams:", error);
    }
  };

  useEffect(() => {
    const fetchSubjects = async () => {
      try {
        const staticStreamId = 1; // Replace with the actual stream ID you want to use
        const { data } = await axios.get(
          `https://admin.akclasses.in/api/stream/${staticStreamId}`,
        );
        console.log("STATIC SUBJECTS", data.stream.subject_masters);
        setSubjects(data.stream.subject_masters);
      } catch (error) {
        console.error("Error fetching subjects:", error);
      }
    };

    fetchSubjects();
  }, []);

  const handleWings = async (e) => {
    const { name, value } = e.target;
    setFAlert(false);
    setSubject(value);

    try {
      const { data } = await axios.get(
        `${Constants.getUrls.subjectFilter}?subject_id=${value}`,
      );
      setGetSubjectFilter(data[0]);
    } catch (error) {
      console.error("Error fetching subject filter:", error);
    }
  };
  const handleSubjectFilter = async (selectedSubjects) => {
    setSubject(selectedSubjects); // Store selected subjects

    try {
      const filters = [];

      // Loop through selected subject IDs
      for (const id of selectedSubjects) {
        const { data } = await axios.get(
          `${Constants.getUrls.subjectFilter}?subject_id=${id}`,
        );

        // Ensure we are handling the correct format
        if (Array.isArray(data) && data.length > 0) {
          const filtered = data[0].filter(
            (item) => item.subject_id === parseInt(id),
          );
          filters.push(...filtered);
        }
      }

      setSubjectFilterOptions(filters); // Set the available filter options

      // Set subjectFilters in formData so that it's auto-selected in the dropdown
      setFormData((prev) => ({
        ...prev,
        subjectFilters: filters.map((filter) => filter.id), // Set the filter IDs in formData
      }));
    } catch (error) {
      console.error("Error fetching subject filter:", error);
      setSubjectFilterOptions([]); // Ensure no filters are shown on error
    }
    console.log("THiS data filter", handleSubjectFilter);
  };

  const attemptWiseWings = async (e) => {
    const { name, value } = e.target;
    setSubject(value);

    try {
      const { data } = await axios.get(
        `https://admin.akclasses.in/api/subjectWings/${value}`,
      );
      setBatch_wings(data.wings);
    } catch (error) {
      console.error("Error fetching attempt wise wings:", error);
    }
  };

  const fetchBatches = async (wingId) => {
    try {
      const { data } = await axios.get(
        `https://admin.akclasses.in/api/wingBatch/${wingId}`,
      );
      const tempBatches = data.data.map((item) => ({
        label: item.batch?.batch_name || "Unnamed Batch",
        value: item.batch?.id || "",
      }));

      setBatches(tempBatches);
    } catch (error) {
      console.error("Error fetching batches:", error);
    }
  };
  // 2. Handle Input Change (Wing Select + trigger fetch)
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
      // clear previously selected batch if wing changes
      ...(name === "batchwings" ? { batch: [] } : {}),
    }));
    if (name === "batchwings") {
      fetchBatches(value); // fetch based on selected wing
    }
  };

  // 3. useEffect to prefill batch data (for update case)
  useEffect(() => {
    if (formData.batchwings) {
      fetchBatches(formData.batchwings);
    }
  }, [formData.batchwings]);

  const token = localStorage.getItem("accessToken");
  const handleSubmit1 = async (e) => {
    e.preventDefault();

    if (
      selectedSubjects?.length === 0 ||
      !formData?.language ||
      !formData?.payment_gateway
    ) {
      setRequiredFields(true);
      return;
    }

    try {
      setRequiredFields(false);

      const productData = {
        product_id: formData?.apple_product_id,
        apple_id: formData?.apple_id,
      };

      const COMMON_GD_LINK = JSON.stringify(productData);

      const fd = new FormData();
      fd.append("faculty", "1");
      fd.append("ak_share", formData?.akshare);
      fd.append("discount_amount", formData?.discount);
      fd.append("cash_amount", formData?.cashback);
      fd.append("category", category);
      fd.append("sku", 101);
      fd.append("title", formData?.title);
      fd.append("short_description", formData.short_description);
      // fd.append("description", proDesc);
      fd.append("description", courseDetails);
      fd.append("duration", formData?.duration);
      fd.append("price", " ");
      fd.append("combo_type", formData?.combo_type);
      fd.append("price_1", " ");
      fd.append("image_path", img);
      fd.append("thumb_image", img); // same file used

      // fd.append("what_learn", specification);
      fd.append("what_learn", formData?.selectedColor);
      fd.append("syllabus_pdf", index);
      fd.append("common_link", COMMON_GD_LINK);
      // fd.append("common_link", gcLink);
      fd.append("window_link", gwLink);
      fd.append("android_link", gaLink);
      fd.append("demo_link", formData?.demoLink1);
      fd.append("demo_link1", formData?.demoLink2);
      fd.append("demo_link2", formData?.demoLink3);
      fd.append("demo_link3", formData?.demoLink4);
      fd.append("google_sheet_details", formData?.googlesheetdetails);
      fd.append("level", " ");
      fd.append("stream", " ");
      fd.append("offer_type", formData?.offer_type);
      fd.append("payment_gateway", formData?.payment_gateway);
      fd.append("ordermailtemplate", formData?.ordermailtemplate);
      fd.append("shippingmailtemplate", formData?.shippingmailtemplate);
      fd.append("language", formData?.language);
      fd.append("subject_master_id", selectedSubjects);
      fd.append("subject_filter_ids", selectedFilter);

      formData.subjects.forEach((subjectId) => {
        fd.append("subject_ids[]", subjectId);
      });

      formData.subjectFilters.forEach((subjectId1) => {
        fd.append("subject_filter_ids[]", subjectId1);
      });

      fd.append("value", formData?.value);
      fd.append("curriculum_doubts", " ");
      fd.append("curriculum_doubts_pdf", " ");
      fd.append("type", "COURSES");
      fd.append("faculty_detail", "");
      fd.append("batch_wings_id", formData.batchwings);

      formData.batch.forEach((id) => {
        fd.append("batch_id[]", id); // Notice the [] to indicate array
      });
      fd.append("faculty_detail", JSON.stringify(faculty));
      fd.append("attempt", 2025);
      if (
        formData.showTestSeries === "Yes" &&
        formData.includeTestSeries !== null
      ) {
        fd.append("include_test_series", formData.includeTestSeries);
      } else {
        fd.append("include_test_series", null); // Send null if "No"
      }
      fd.append(
        "amenity_details",
        JSON.stringify(formData.amenitiesDetails) || [],
      );
      // fd.append("amenity_ids", formData.amenitiesIds.join(",") || " ");
      // fd.append("amenity_ids", " ");
      fd.append(
        "amenity_ids",
        JSON.stringify(selected_amenities?.map((item) => item.value) || " "),
      );

      // fd.append("amenity_ids", " ");

      // Ensure productId is present to update
      if (!id) {
        console.error("Product ID is required for updating the course");
      }

      const res = await axios.post(
        `https://admin.akclasses.in/api/course/update/${id}`,
        fd,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (res) {
        console.log("COURSE UPDATED Successfully", res);
        setShowSuccessPopup(true);

        setIsSubmitted(true);
      }
    } catch (error) {
      console.log("Error while updating course", error);
    }
  };
  const handleSecondFormSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!secondFormData?.sku?.trim()) {
      newErrors.sku = "SKU is required.";
    }
    if (!secondFormData?.price || secondFormData.price <= 0) {
      newErrors.price = "Price is required.";
    }
    if (!secondFormData?.attempt_id) {
      newErrors.attempt_id = "Attempt is required.";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({}); // clear previous errors

    try {
      const fd = new FormData();
      fd.append("sku", secondFormData?.sku);
      fd.append("price", secondFormData?.price);
      fd.append("attempt_id", secondFormData?.attempt_id);

      let res;

      if (editVariantId) {
        res = await axios.post(
          `https://admin.akclasses.in/api/variant/updateNew/${editVariantId}`,
          fd,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          },
        );
      } else {
        res = await axios.post(
          `https://admin.akclasses.in/api/variant/createNew/${id}`,
          fd,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          },
        );
      }

      if (res?.data?.status === "success") {
        console.log("Variant saved successfully");
        getCourseVariant(id);
        setSecondFormData({ attempt_id: "", sku: "", price: "" });
        setEditVariantId(null);
        setEditIndex(null);
      } else {
        console.log("Failed to save variant", res?.data);
      }
    } catch (error) {
      console.log("Error while saving variant", error);
    }
  };

  const handleSecondInputChange = (e) => {
    const { name, value } = e.target;
    setSecondFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleEdit = (index) => {
    const entry = variants[index];
    setEditIndex(index);
    setEditVariantId(entry.id);

    setSecondFormData({
      attempt_id: entry.attempt_id || "", // ✅ use attempt_id
      sku: entry.sku || "",
      price: entry.price || "",
    });
  };

  const handleCancel = () => {
    setEditIndex(null);
    setSecondFormData({
      attempt_id: "",
      sku: "",
      price: "",
    });
  };

  const history = useHistory();

  const handleCancel1 = () => {
    history.goBack(); // Go to the previous page
  };

  const getCourseVariant = async (id) => {
    try {
      console.log("Ok ID:", id);
      const response = await axios.get(
        `https://admin.akclasses.in/api/course/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const variantData = response.data?.product?.variant || [];
      console.log("This variant Now", variantData);
      setVariants(variantData);
    } catch (error) {
      console.log("Error fetching variant data:", error);
    }
  };
  useEffect(() => {
    if (isSubmitted && id) {
      getCourseVariant(id);
    }
  }, [isSubmitted, id]);

  const handleFile = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImg(file);
      setImgPreview(URL.createObjectURL(file)); // replaces the old image preview
    }
  };

  useEffect(() => {
    const fetchAttempts = async () => {
      try {
        const res = await axios.get(
          "https://admin.akclasses.in/api/activeAttempts",
        );
        if (res?.data) {
          setAttemptOptions(res.data);
        }
      } catch (err) {
        console.error("Error fetching attempt options:", err);
      }
    };

    fetchAttempts();
  }, []);

  // useEffect(() => {
  //   if (productId) {
  //     getCourseVariant(productId);
  //   }
  // }, [productId]);
  const handleDelete = async (variantId) => {
    try {
      const res = await axios.post(
        `https://admin.akclasses.in/api/variant/delete/${variantId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`, // include if required
          },
        },
      );

      if (res.status === 200) {
        // Filter out the deleted variant from state
        const updatedVariants = variants.filter((v) => v.id !== variantId);
        setVariants(updatedVariants);
        console.log("Variant deleted successfully.");
      } else {
        console.error(
          "Failed to delete variant. Server responded with:",
          res.status,
        );
      }
    } catch (error) {
      console.error("Error deleting variant:", error);
    }
  };
  const subjectOptions = subjects.map((sub) => ({
    value: String(sub.subject_master.id),
    label: sub.subject_master.title,
  }));

  console.log("subjectOptionsThis", subjectOptions);

  useEffect(() => {
    if (id) {
      console.log("Fetching batches for courseId:", courseId); // Log courseId
      fetchBatches(id);
    }
  }, [id]);

  const fetchBatches1 = async () => {
    try {
      const res = await axios.get(
        `https://admin.akclasses.in/api/show_alloted_batches?course_id=${id}`,
      );
      console.log("API Response:", res);
      if (res.data.status === "success") {
        setAddedBatches(res.data.addedData);
        setNotAddedBatches(res.data.notAddedData);
        setLoading(false);
      } else {
        console.error("Error fetching batches");
      }
    } catch (error) {
      console.error("API error:", error);
      setLoading(false);
    }
  };

  const allBatches = [...addedBatches, ...notAddedBatches];
  const batchOptions = allBatches.map((batch) => ({
    value: batch.id,
    label: batch.batch_name,
  }));

  const selectedBatches = batchOptions.filter(
    (option) =>
      Array.isArray(formData.batch) && formData.batch.includes(option.value),
  );
  console.log("Selected options:", selectedBatches);

  useEffect(() => {
    const fetchCourseData = async () => {
      try {
        const courseResponse = await axios.get(
          `https://admin.akclasses.in/api/course/${id}`,
        );
        const formData = courseResponse.data.product;
        console.log("TOday", formData.subject_ids);
        console.log("FORM EDIT DATA", courseResponse);
        setSelectedSubjects(formData.subject_ids || []);

        const filtersubject =
          courseResponse.data.product.subject_filter_ids_data;
        console.log("FilterDataNow: ", filtersubject);
        setSubjectFilterOptions(filtersubject);
        console.log("Fetched course data:", formData);

        const templateRes = await axios.get(
          "https://admin.akclasses.in/api/mailTemplate?type=Order",
        );
        const templates = templateRes.data.data;
        console.log("order my data", templates);

        // Map for dropdown
        const options = templates.map((tpl) => ({
          value: tpl.id,
          label: tpl.title,
        }));
        setTemplateOptions(options);

        const shippingTemplateRes = await axios.get(
          "https://admin.akclasses.in/api/mailTemplate?type=Shipping",
        );
        const shippingTemplates = shippingTemplateRes.data.data;
        console.log("shipping my data", shippingTemplates);

        // Map for dropdown
        const shippingOptions = shippingTemplates.map((tpl) => ({
          value: tpl.id,
          label: tpl.title,
        }));
        setShippingTemplateOptions(shippingOptions);

        const formattedFaculty = formData.faculty.map((f) => ({
          fid: f.faculty_id,
          fName: f.faculty?.name || "",
          fshare: parseFloat(f.faulty_share),
        }));

        setFaculty(formattedFaculty); // ✅ so table uses same format
        setFacultyIds(formattedFaculty.map((f) => f.fid)); // for preventing duplicates

        const selectedBatchIds = formData.course_batches.map(
          (item) => item.batch_id,
        );
        const selectedBatchObjects = batchOptions.filter((batch) =>
          selectedBatchIds.includes(batch.value),
        );

        const prefilledFilters = filtersubject.map((item) => item.id);
        // Ensure that `formData.subject_ids` is available
        const parsedGDLink = JSON.parse(formData.COMMON_GD_LINK);

        setFormData({
          combo_type: formData.COMBO_TYPE || "N/A",
          subjectFilters: prefilledFilters || "N/A",
          subjects: formData.subject_ids || "N/A", // ✅ Use directly
          batch: selectedBatchIds,
          title: formData.TITLE || "N/A",
          duration: formData.DURATION || "N/A",
          akshare: formData.AKCLASSES_SHARE || "N/A",
          discount: formData.DISCOUNT_AMOUNT || "N/A",
          value: formData.VALUE ?? "N/A",
          googlesheetdetails: formData.google_sheet || "N/A",
          ordermailtemplate: formData.ordermailtemplate || null,
          shippingmailtemplate: formData.shippingmailtemplate || null,
          payment_gateway: formData.payment_gateway || "N/A",
          offer_type: formData.OFFER_TYPE || "N/A",
          demoLink1: formData.DEMO_LINK || "N/A",
          demoLink2: formData.DEMO_LINK1 || "N/A",
          demoLink3: formData.DEMO_LINK2 || "N/A",
          demoLink4: formData.DEMO_LINK3 || "N/A",
          short_description: formData.SHORT_DESCRIPTION || "N/A",
          language: formData.language || "N/A",
          //testSeries: formData.include_test_series || "N/A",
          cashback: formData.CASHBACK_AMOUNT || "N/A",
          img: formData.IMAGE_PATH ?? null,
          batchwings: formData.batch_wings_id ?? null,
          faculty: formData.faculty,
          includeTestSeries: formData.include_test_series || "",
          selectedSeriesId: formData.include_test_series || "", // match ID
          showTestSeries: formData.include_test_series ? "Yes" : "No", // prefill dropdown
          apple_product_id: parsedGDLink?.product_id || "",
          apple_id: parsedGDLink?.apple_id || "",
          selectedColor: formData.WHAT_LEARN || "#000000",
          // selected_amenities: categoryData?.amenity_details || [],
        });

        if (formData?.DESCRIPTION) {
          setCourseDetails(formData?.DESCRIPTION);
        }

        if (!formData.ordermailtemplate && templates.length > 0) {
          setFormData((prev) => ({
            ...prev,
            ordermailtemplate: templates[0].id,
          }));
        }

        if (!formData.shippingmailtemplate && shippingTemplates.length > 0) {
          setFormData((prev) => ({
            ...prev,
            shippingmailtemplate: shippingTemplates[0].id,
          }));
        }

        // const secondFormData = courseResponse.data.product.variant;
        // const firstVariant = secondFormData?.[0]; // safely get the first variant

        // if (firstVariant) {
        //   setSecondFormData({
        //     attempt_id: firstVariant.attempt_id || "",
        //     sku: firstVariant.sku || "",
        //     price: firstVariant.price || "",
        //   });

        //   console.log("Form data prefilled with:", {
        //     attempt_id: firstVariant.attempt_id,
        //     sku: firstVariant.sku,
        //     price: firstVariant.price,
        //   });
        // } else {
        //   console.warn("No variant data found.");
        // }
      } catch (error) {
        console.error("Error fetching course data:", error);
      }
    };

    if (id) {
      fetchCourseData();
    }
  }, [id]);

  const handleSubjectChange = (selectedOptions) => {
    let selectedValues = selectedOptions.map((opt) => opt.value);

    if (formData?.combo_type === "Normal") {
      // Only keep the first selected value for "Normal" combo type
      selectedValues = selectedValues.slice(0, 1);
    }

    setSelectedSubjects(selectedValues);

    setFormData({
      ...formData,
      subjects: selectedValues, // ✅ use this directly
    });
    setDAlert(false);
    handleSubjectFilter(selectedValues);
  };

  useEffect(() => {
    console.log("Updated formData:", formData);
  }, [formData]);

  const headerStyle = {
    padding: "10px",
    textAlign: "center",
    border: "1px black solid",
    borderCollapse: "collapse",
  };

  const cellStyle = {
    padding: "10px",
    textAlign: "center",
    border: "1px black solid",
    borderCollapse: "collapse",
  };

  //Add Faculty
  const handleAdd = () => {
    if (!facultyId || !facultyshare) {
      setBAlert(true);
      return;
    }

    // Prevent duplicates
    if (!facultyIds.includes(facultyId)) {
      const selectedFaculty = facultyArr.find(
        (f) => parseInt(f.id) === parseInt(facultyId),
      );

      const updatedFaculty = [
        ...faculty, // <-- includes existing + new
        {
          fid: facultyId,
          fName: selectedFaculty.name,
          fshare: parseFloat(facultyshare),
        },
      ];

      setFaculty(updatedFaculty); // ✅ update state
      setFacultyIds([...facultyIds, facultyId]);

      // Optional: update commission/share
      const newCommission = updatedFaculty.reduce(
        (acc, cur) => acc + cur.fshare,
        0,
      );
      setFacultyCommission(newCommission);
      setAkshare(100 - newCommission);
      setAtLeast(updatedFaculty.length === 0);
    }

    // Close modal
    setVisible(false);
  };
  const handleDeleteFaculty = (indexToRemove) => {
    // Remove the faculty at the given index
    const updatedFaculty = faculty.filter((_, i) => i !== indexToRemove);

    // Update the faculty IDs list
    const updatedFacultyIds = updatedFaculty.map((f) => f.fid);

    // Update states
    setFaculty(updatedFaculty);
    setFacultyIds(updatedFacultyIds);

    // Optionally, update commission/share if you're tracking it
    const newCommission = updatedFaculty.reduce(
      (acc, cur) => acc + cur.fshare,
      0,
    );
    setFacultyCommission(newCommission);
    setAkshare(100 - newCommission);
    setAtLeast(updatedFaculty.length === 0);
  };

  const handleInputChangeTestSeries = (e) => {
    const value = e.target.value;
    setHasUserChangedTestSeries(true); // ✅ block auto-patch from useEffect

    setFormData((prev) => ({
      ...prev,
      showTestSeries: value,
      selectedSeriesId: "", // Clear selected series ID
      includeTestSeries: value === "Yes" ? prev.includeTestSeries : null, // null for "No"
    }));

    if (value === "Yes") {
      fetchTestSeriesOptions();
    } else {
      setTestSeriesOptions([]); // Clear options if "No" is selected
    }
  };

  const fetchTestSeriesOptions = async () => {
    try {
      const response = await axios.get(
        "https://admin.akclasses.in/api/courses?type=Test_Series&per_page=10",
      );
      const formatted = response.data?.data?.map((item) => ({
        id: item.ID,
        title: item.TITLE,
      }));
      setTestSeriesOptions(formatted || []);
      return formatted || [];
    } catch (error) {
      console.error("Error fetching test series:", error);
      return [];
    }
  };
  useEffect(() => {
    const prefillTestSeries = async () => {
      if (hasUserChangedTestSeries) return; // Don't overwrite user choice

      // Convert the string "null" to actual null
      const includeTestSeries =
        formData.includeTestSeries === "null"
          ? null
          : formData.includeTestSeries;

      // Check if includeTestSeries is null
      if (includeTestSeries === null) {
        setFormData((prev) => ({
          ...prev,
          showTestSeries: "No", // Set to "No" if null
          selectedSeriesId: "", // Clear selected series ID
        }));
      } else if (includeTestSeries) {
        const options = await fetchTestSeriesOptions();
        const match = options.find(
          (item) => item.id.toString() === includeTestSeries.toString(),
        );

        if (match) {
          setFormData((prev) => ({
            ...prev,
            showTestSeries: "Yes",
            selectedSeriesId: match.id.toString(),
          }));
        }
      }
    };

    prefillTestSeries();
  }, [formData.includeTestSeries, hasUserChangedTestSeries]);

  const handleSeriesSelection = (e) => {
    const selectedId = e.target.value;

    setFormData((prev) => ({
      ...prev,
      selectedSeriesId: selectedId,
      includeTestSeries: selectedId,
    }));
  };

  const handleAmenityChange = (amenity) => {
    setFormData((prev) => {
      const amenitiesIds = Array.isArray(prev.amenitiesIds)
        ? prev.amenitiesIds
        : [];

      const amenitiesDetails = Array.isArray(prev.amenitiesDetails)
        ? prev.amenitiesDetails
        : [];

      const alreadySelected = amenitiesIds?.includes(amenity.id);

      if (alreadySelected) {
        return {
          ...prev,
          amenitiesIds: amenitiesIds.filter((id) => id !== amenity.id),
          amenitiesDetails: amenitiesDetails.filter(
            (item) => item.id !== amenity.id,
          ),
        };
      } else {
        return {
          ...prev,
          amenitiesIds: [...amenitiesIds, amenity.id],
          amenitiesDetails: [...amenitiesDetails, amenity],
        };
      }
    });
  };

  if (!token) {
    console.log("Token not found. Please login again.");
    return null;
  }

  return (
    <div className="container-one">
      <div className="container-two">
        <form onSubmit={handleSubmit1} className="container-form">
          <div className="row">
            <div className="col-12 col-md-4">
              <div className="form-group mt-3 text-dark">
                <label class="text-dark" htmlFor="simple-select ">
                  Course Type
                </label>
                <select
                  className="form-control"
                  id="simple-select"
                  name="combo_type"
                  value={formData.combo_type}
                  onChange={handleInputChange} // ✅ this updates formData correctly
                >
                  <option value="">Select Course Type</option>
                  {type.map((v, i) => (
                    <option key={i} value={v}>
                      {v}
                    </option>
                  ))}
                </select>
              </div>

              {aAlert && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>
            <div className="col-12 col-md-4 container-two">
              <div className="form-group mt-3">
                <label className="text-dark" htmlFor="subject-select">
                  Subject
                </label>
                <Select
                  isMulti
                  name="subjects"
                  options={subjectOptions}
                  value={subjectOptions.filter((opt) =>
                    selectedSubjects.includes(opt.value),
                  )}
                  onChange={handleSubjectChange}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      borderRadius: "50px",
                      borderColor: "black",
                      boxShadow: state.isFocused
                        ? "0 0 0 5px rgba(86, 160, 239, 0.4)"
                        : "none",
                      "&:hover": {
                        borderColor: "black",
                      },
                    }),
                    multiValue: (base) => ({
                      ...base,
                      borderRadius: "30px",
                    }),
                  }}
                />
              </div>

              {dAlert && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label className="text-dark" htmlFor="subject-filter-select">
                  Subject Filter
                </label>
                <Select
                  isMulti
                  name="subjectFilters"
                  options={subjectFilterOptions.map((item) => ({
                    value: item.id,
                    label: item.title,
                  }))}
                  value={subjectFilterOptions
                    .filter((item) => formData.subjectFilters.includes(item.id))
                    .map((item) => ({
                      value: item.id,
                      label: item.title,
                    }))}
                  onChange={(selectedOptions) => {
                    const selectedIds = selectedOptions.map((opt) => opt.value);

                    setSelectedFilter(selectedIds);
                    setFormData((prev) => ({
                      ...prev,
                      subjectFilters: selectedIds, // Add to formData
                    }));
                  }}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      borderRadius: "50px",
                      borderColor: "black",
                      boxShadow: state.isFocused
                        ? "0 0 0 5px rgba(86, 160, 239, 0.4)"
                        : "none",
                      "&:hover": {
                        borderColor: "rgba(0, 0, 0, 0.4)",
                      },
                    }),
                    multiValue: (base) => ({
                      ...base,
                      borderRadius: "30px",
                    }),
                  }}
                />
              </div>
            </div>
            {/* <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label class="text-dark" htmlFor="simple-select">
                  Attempt
                </label>
                <select
                  className="form-control"
                  id="simple-select"
                  name="attempt"
                  required
                  value={formData.attempt} // ✅ use formData.attempt
                  onChange={handleInputChange} // ✅ reuse your generic handler
                >
                  <option value="">Select Attempt</option>
                  {attempts.map((att, i) => (
                    <option key={i} value={att.id}>
                      {att.title}
                    </option>
                  ))}
                </select>
              </div>

              {aAlert && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div> */}
            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label className="text-dark" htmlFor="batchwings">
                  Select Batch Wings
                </label>
                <select
                  className="form-control"
                  id="batchwings"
                  name="batchwings"
                  required
                  value={formData.batchwings}
                  onChange={handleInputChange}
                >
                  <option value="">Select Batch Wings</option>
                  {Array.isArray(batchwings) &&
                    batchwings.map((wing) => (
                      <option key={wing.id} value={wing.id}>
                        {wing.title}
                      </option>
                    ))}
                </select>

                {fAlert && (
                  <div>
                    <span style={{ color: "red" }}>*required</span>
                  </div>
                )}
              </div>
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label className="text-dark" htmlFor="simple-select">
                  Select Batch
                </label>
                <Select
                  isMulti
                  name="batches"
                  options={batches}
                  value={batches.filter((item) =>
                    formData.batch.includes(item.value),
                  )}
                  onChange={(selectedOptions1) => {
                    const selectedBatchIds = selectedOptions1.map(
                      (opt) => opt.value,
                    );
                    setFormData((prev) => ({
                      ...prev,
                      batch: selectedBatchIds,
                    }));
                  }}
                  placeholder="Select Batch (choose Batch Wings first)"
                  noOptionsMessage={() =>
                    formData.batchwings
                      ? "No batches available for this wing"
                      : "Please select a batch wing first"
                  }
                  className="basic-multi-select"
                  classNamePrefix="select"
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      borderRadius: "50px",
                      borderColor: "black",
                      boxShadow: state.isFocused
                        ? "0 0 0 5px rgba(86, 160, 239, 0.4)"
                        : "none",
                      "&:hover": {
                        borderColor: "rgba(0, 0, 0, 0.4)",
                      },
                    }),
                    multiValue: (base) => ({
                      ...base,
                      borderRadius: "30px",
                    }),
                  }}
                />
              </div>

              {fAlert && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>

            {/* <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label class="text-dark" htmlFor="sku">
                  SKU
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="sku"
                  name="sku"
                  value={formData.sku}
                  onChange={(e) => {
                    handleInputChange(e);
                    setFAlert(false); // Optional: for showing/hiding alerts
                  }}
                  required
                />
              </div>

              {fAlert && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div> */}

            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label class="text-dark" htmlFor="title">
                  Title
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="title"
                  name="title"
                  value={formData.title}
                  onChange={(e) => {
                    handleInputChange(e); // Your reusable input handler
                    setFAlert(false); // Optional: alert handling
                    setFormData({ ...formData, title: e.target.value });
                  }}
                  required
                />
              </div>

              {fAlert && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label class="text-dark" htmlFor="duration">
                  Duration
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="duration"
                  name="duration"
                  value={formData.duration}
                  onChange={(e) => {
                    handleInputChange(e); // universal handler updates formData
                    setFAlert(false); // optional alert handling
                  }}
                  required
                />
              </div>

              {fAlert && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label class="text-dark" htmlFor="akshare">
                  AK Share (%)
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="akshare"
                  name="akshare"
                  value={formData.akshare}
                  onChange={(e) => {
                    handleInputChange(e); // universal handler
                    setFAlert(false); // optional alert
                  }}
                  required
                />
              </div>

              {fAlert && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label
                  class="text-dark"
                  htmlFor="simple-select-payment-gateway"
                >
                  Payment Gateway
                </label>
                <select
                  className="form-control"
                  id="simple-select-payment-gateway"
                  name="payment_gateway"
                  value={formData.payment_gateway}
                  onChange={(e) => {
                    handleInputChange(e); // Updates formData
                    setGatewayAlert(false); // Optional alert reset
                  }}
                  required
                >
                  <option value="">Select Payment Gateway</option>
                  <option value="Razorpay">Razorpay</option>
                  <option value="PhonePe">PhonePe</option>
                </select>
              </div>

              {gatewayAlert && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label class="text-dark" htmlFor="simple-select-order-template">
                  Order Mail Template
                </label>
                <select
                  className="form-control"
                  id="simple-select-order-template"
                  name="ordermailtemplate"
                  value={formData.ordermailtemplate ?? ""}
                  onChange={(e) => handleInputChange(e)}
                  required
                >
                  <option value="" disabled>
                    Select a template
                  </option>
                  {templateOptions.length > 0 ? (
                    templateOptions.map((template) => (
                      <option key={template.value} value={template.value}>
                        {template.label}
                      </option>
                    ))
                  ) : (
                    <option disabled>No templates available</option>
                  )}
                </select>
              </div>
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label class="text-dark" htmlFor="simple-select-order-template">
                  Shipping Mail Template
                </label>
                <select
                  className="form-control"
                  id="simple-select-shipping-template"
                  name="shippingmailtemplate"
                  value={formData.shippingmailtemplate ?? ""}
                  onChange={(e) => handleInputChange(e)}
                  required
                >
                  <option value="" disabled>
                    Select a template
                  </option>
                  {shippingTemplateOptions.length > 0 ? (
                    shippingTemplateOptions.map((template) => (
                      <option key={template.value} value={template.value}>
                        {template.label}
                      </option>
                    ))
                  ) : (
                    <option disabled>No templates available</option>
                  )}
                </select>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-md-4">
              <div className="form-group mt-3">
                <label class="text-dark" htmlFor="simple-select-language">
                  Language
                </label>
                <select
                  className="form-control"
                  id="simple-select-language"
                  name="language"
                  value={formData.language}
                  onChange={(e) => handleInputChange(e)} // Update formData
                  required
                >
                  <option value="">Select Language</option>
                  {languages.map((lang, index) => (
                    <option key={index} value={lang}>
                      {lang}
                    </option>
                  ))}
                </select>
              </div>

              {langAlert && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>
            <div className="col-12 col-sm-6 col-md-4">
              <div className="form-group mt-3">
                <label
                  className="text-dark"
                  htmlFor="simple-select-test-series"
                >
                  Test Series
                </label>
                <select
                  className="form-control"
                  name="showTestSeries"
                  value={formData.showTestSeries}
                  onChange={handleInputChangeTestSeries}
                  required
                >
                  <option value="">Select Test Series</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>
            </div>

            {formData.showTestSeries === "Yes" && (
              <div className="col-12 col-sm-6 col-md-4">
                <div className="form-group mt-3">
                  <label className="text-dark" htmlFor="test-series-select">
                    Select Test Series Batch
                  </label>
                  <select
                    className="form-control"
                    name="selectedSeriesId"
                    value={formData.selectedSeriesId}
                    onChange={handleSeriesSelection}
                    required
                  >
                    <option value="">Select Batch</option>
                    {testSeriesOptions.map((series) => (
                      <option key={series.id} value={series.id}>
                        {series.title}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}

            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label className="text-dark" htmlFor="cashback">
                  Cashback Amount
                </label>
                <div
                  className="input-container"
                  style={{ position: "relative" }}
                >
                  <input
                    type="text"
                    className="form-control"
                    id="cashback"
                    name="cashback"
                    value={formData.cashback}
                    onChange={handleInputChange}
                    required
                    style={{
                      paddingLeft: "30px", // Padding to make room for the icon
                      paddingRight: "10px", // Padding on the right side to make room for the border
                    }}
                  />
                  <span
                    className="fa fa-rupee-sign"
                    style={{
                      position: "absolute",
                      left: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      fontSize: "18px",
                    }}
                  ></span>
                </div>
              </div>

              {fAlert && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label className="text-dark" htmlFor="demoLink1">
                  Demo Link
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="demoLink1"
                  name="demoLink1"
                  value={formData.demoLink1}
                  onChange={handleInputChange}
                  required
                />
              </div>
              {fAlert && !formData.demoLink1 && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label className="text-dark" htmlFor="demoLink2">
                  Blue Tag
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="demoLink2"
                  name="demoLink2"
                  value={formData.demoLink2}
                  onChange={handleInputChange}
                  required
                />
              </div>
              {fAlert && !formData.demoLink2 && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label className="text-dark" htmlFor="demoLink3">
                  Views
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="demoLink3"
                  name="demoLink3"
                  value={formData.demoLink3}
                  onChange={handleInputChange}
                  required
                />
              </div>
              {fAlert && !formData.demoLink3 && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label className="text-dark" htmlFor="demoLink4">
                  Validity
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="demoLink4"
                  name="demoLink4"
                  value={formData.demoLink4}
                  onChange={handleInputChange}
                  required
                />
              </div>
              {fAlert && !formData.demoLink4 && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label class="text-dark" htmlFor="googlesheetdetails">
                  Google Sheet Details
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="googlesheetdetails"
                  name="googlesheetdetails"
                  value={formData.googlesheetdetails}
                  onChange={handleInputChange} // This will handle updating formData
                  required
                />
              </div>

              {fAlert && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label className="text-dark" htmlFor="discount">
                  Discount Amount
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="discount"
                  name="discount"
                  value={formData.discount}
                  onChange={handleInputChange}
                  required
                />
              </div>

              {fAlert && !discount && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label className="text-dark" htmlFor="offer_type">
                  Offer Type
                </label>
                <select
                  className="form-control"
                  id="offer_type"
                  name="offer_type"
                  value={formData.offer_type}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select Offer Type</option>
                  <option value="Amount">Amount</option>
                  <option value="Percent">Percent</option>
                </select>
              </div>

              {fAlert && !formData.offer_type && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label className="text-dark" htmlFor="value">
                  Offer Value
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="value"
                  name="value"
                  value={formData.value}
                  onChange={handleInputChange}
                  required
                />
              </div>

              {fAlert && !secondFormData.value && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label className="text-dark" htmlFor="short_description">
                  Short Description
                </label>
                <textarea
                  className="form-control"
                  id="short_description"
                  name="short_description"
                  rows="1"
                  value={formData.short_description}
                  onChange={handleInputChange}
                  required
                ></textarea>
              </div>
              {fAlert && !formData.short_description && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label className="text-dark" htmlFor="value">
                  Apple Product ID
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="apple_product_id"
                  name="apple_product_id"
                  value={formData.apple_product_id}
                  onChange={handleInputChange}
                  required
                />
              </div>

              {fAlert && !formData.apple_product_id && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>
            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label className="text-dark" htmlFor="value">
                  Apple ID
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="apple_id"
                  name="apple_id"
                  value={formData.apple_id}
                  onChange={handleInputChange}
                  required
                />
              </div>

              {fAlert && !formData.apple_id && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>

            <div className="col-12 col-md-4">
              <div className="form-group mt-3">
                <label className="text-dark" htmlFor="color">
                  Select Color
                </label>

                <input
                  type="color"
                  className="form-control form-control-color"
                  id="selectedColor"
                  name="selectedColor"
                  value={formData.selectedColor}
                  onChange={handleInputChange}
                  title="Choose your color"
                  style={{ height: "45px", width: "100%" }}
                  required
                />
              </div>

              {fAlert && !formData.selectedColor && (
                <div>
                  <span style={{ color: "red" }}>*required</span>
                </div>
              )}
            </div>

            <div className="col-6 mt-4">
              <label style={{ fontSize: "16px" }} className="text-dark mb-2">
                Select Amenities
              </label>
              <div style={{ position: "relative", zIndex: 9999 }}>
                <MultiSelect
                  disableSearch
                  options={amenities.map((item) => ({
                    label: item.title,
                    value: item.id,
                  }))}
                  value={selected_amenities}
                  onChange={(data) => {
                    setSelected_amenities(data);
                  }}
                  // onChange={(data) => {
                  //   setFormData((prev) => ({
                  //     ...prev,
                  //     selected_amenities: data,
                  //   }));
                  // }}
                  labelledBy="Select Amenities"
                />
              </div>

              {fAlert && selected_amenities?.length === 0 && (
                <div
                  style={{
                    marginTop: "10px",
                    color: "#d9534f",
                    fontSize: "13px",
                  }}
                >
                  *Please select at least one amenity
                </div>
              )}
            </div>

            <div style={{ marginTop: "30px" }}>
              <Grid item xs={12}>
                <table
                  style={{
                    width: "100%",
                    border: "1px black solid",
                    borderCollapse: "collapse",
                  }}
                >
                  <thead>
                    <tr>
                      <th style={headerStyle}>Sr.No</th>
                      <th style={headerStyle}>Faculty</th>
                      <th style={headerStyle}>Faculty Share</th>
                      <th style={headerStyle}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {faculty.map((v, i) => (
                      <tr key={i}>
                        <td style={cellStyle}>{i + 1}</td>
                        <td style={cellStyle}>{v.fName}</td>
                        <td style={cellStyle}>{v.fshare}</td>
                        <td style={cellStyle}>
                          <input
                            style={{
                              backgroundColor: "red",
                              borderRadius: "10%",
                              border: "none",
                              padding: "10px",
                              color: "white",
                            }}
                            type="button"
                            value="Delete"
                            onClick={() => handleDeleteFaculty(i)}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Grid>
              {!visible && (
                <GridItem xs={12} sm={12} md={12}>
                  <Button
                    onClick={() => setVisible(true)}
                    className="btn-round"
                    color="success"
                  >
                    Add Faculty
                  </Button>
                </GridItem>
              )}

              <Modal
                visible={visible}
                width="700"
                height="175"
                effect="fadeInUp"
                onClickAway={() => setVisible(false)}
              >
                <GridContainer
                  style={{ paddingLeft: "5px", paddingTop: "20px" }}
                >
                  <GridItem xs={12} sm={12} md={5}>
                    <FormControl fullWidth>
                      <label>Faculty</label>
                      <select
                        style={{ padding: "11px" }}
                        name="facultyId"
                        value={facultyId}
                        onChange={(e) => {
                          setFacultyId(e.target.value);
                          const selected = facultyArr.find(
                            (f) => parseInt(f.id) === parseInt(e.target.value),
                          );
                          if (selected) setFacultyWithName(selected.name);
                        }}
                      >
                        <option value="">Select</option>
                        {facultyArr.map((v, i) => (
                          <option key={i} value={v.id}>
                            {v.name}
                          </option>
                        ))}
                      </select>
                    </FormControl>
                    {bAlert && (
                      <div>
                        <span style={{ color: "red" }}>*required</span>
                      </div>
                    )}
                  </GridItem>

                  <GridItem xs={12} sm={12} md={5}>
                    <CustomInput
                      labelText="Faculty Share"
                      id="float"
                      inputProps={{
                        type: "float",
                        required: true,
                        value: facultyshare,
                        onChange: (e) => setFacultyshare(e.target.value),
                      }}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>

                  <GridItem xs={12} sm={12} md={2}>
                    <Button
                      style={{ marginTop: "20px" }}
                      onClick={handleAdd}
                      className="btn-round"
                      color="success"
                    >
                      Add
                    </Button>
                  </GridItem>
                </GridContainer>
              </Modal>
            </div>
            <div className="col-12">
              <div className="form-group mt-3">
                <label
                  class="text-dark"
                  htmlFor="courseDetails"
                  className="font-weight-bold"
                  style={{ fontSize: "16px", marginBottom: "10px" }}
                >
                  Course Details
                </label>

                <CKEditor
                  editor={ClassicEditor}
                  data={courseDetails}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setCourseDetails(data);
                  }}
                  config={{
                    toolbar: [
                      "heading",
                      "|",
                      "alignment",
                      "|",
                      "bold",
                      "italic",
                      "underline",
                      "fontColor",
                      "fontBackgroundColor",
                      "|",
                      "bulletedList",
                      "numberedList",
                      "highlight",
                      "|",
                      "insertTable",
                      "blockQuote",
                      "|",
                      "undo",
                      "redo",
                    ],
                    table: {
                      contentToolbar: [
                        "tableColumn",
                        "tableRow",
                        "mergeTableCells",
                      ],
                    },
                    alignment: {
                      options: ["left", "center", "right", "justify"],
                    },
                  }}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-12 col-sm-12 col-md-4 mb-3">
                <label htmlFor="img">Upload Image</label>
                <br />
                <input
                  id="img"
                  name="img"
                  onChange={handleFile}
                  accept="image/*"
                  type="file"
                  required={true}
                  className="form-control"
                />
              </div>
              {/* 👇 Image Preview */}
              <div className="mt-2">
                <p className="mb-1">Image Preview:</p>
                <img
                  src={
                    imgPreview || `https://admin.akclasses.in/${formData.img}`
                  }
                  alt="Image Preview"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "150px",
                    borderRadius: "10px",
                    border: "1px solid #ccc",
                  }}
                />
              </div>

              {/* 
              <div className="col-12 col-sm-12 col-md-4 mb-3">
                <label htmlFor="thumb">Thumb Image</label>
                <br />
                <input
                  id="thumb"
                  name="thumb"
                  onChange={handleFile}
                  accept="image/*"
                  type="file"
                  className="form-control"
                />
              </div> */}
            </div>

            {requiredFields && (
              <>
                <div style={{ color: "red", margin: "10px 0px" }}>
                  * Please fill in all the required fields
                </div>
              </>
            )}

            <div className="col-12 my-4">
              {/* Success Popup */}
              {showSuccessPopup && (
                <div
                  style={{
                    position: "fixed",
                    top: "0",
                    left: "0",
                    width: "100vw",
                    height: "100vh",
                    backgroundColor: "rgba(0,0,0,0.5)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 9999,
                  }}
                >
                  <div
                    style={{
                      background: "white",
                      padding: "30px",
                      borderRadius: "10px",
                      minWidth: "300px",
                      textAlign: "center",
                    }}
                  >
                    <h3>Updated successfully!</h3>
                    <button
                      className="btn btn-info"
                      onClick={() => setShowSuccessPopup(false)}
                      style={{ marginTop: "15px" }}
                    >
                      Close
                    </button>
                  </div>
                </div>
              )}
              <div className="d-flex justify-content-start gap-3">
                <button
                  className="btn btn-dark"
                  type="submit"
                  style={{ borderRadius: "8px", padding: "6px 24px" }}
                  onClick={handleSubmit1}
                >
                  Update
                </button>

                <button
                  className="btn btn-dark"
                  type="button"
                  style={{ borderRadius: "8px", padding: "6px 24px" }}
                  onClick={handleCancel1}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      {isSubmitted && (
        <div className="mt-4">
          <div
            className="card shadow-sm"
            style={{ borderRadius: "20px", padding: "24px" }}
          >
            <h6 className="card-title mb-4">Variants</h6>
            <form onSubmit={handleSecondFormSubmit}>
              <div className="row g-3">
                <div className="col-12 col-md-4">
                  <div className="form-group">
                    <label htmlFor="attempt">Attempt</label>
                    <select
                      id="attempt"
                      name="attempt_id"
                      className="form-control"
                      value={secondFormData.attempt_id}
                      onChange={handleSecondInputChange}
                    >
                      <option value="">Select Attempt</option>
                      {attemptOptions.map((opt) => (
                        <option key={opt.id} value={opt.id}>
                          {opt.title}
                        </option>
                      ))}
                    </select>
                    {errors.attempt_id && (
                      <small className="text-danger">{errors.attempt_id}</small>
                    )}
                  </div>
                </div>
                <div className="col-12 col-md-4">
                  <div className="form-group">
                    <label htmlFor="sku">SKU</label>
                    <input
                      type="text"
                      className="form-control"
                      id="sku"
                      name="sku"
                      value={secondFormData.sku}
                      onChange={handleSecondInputChange}
                    />
                    {errors.sku && (
                      <small className="text-danger">{errors.sku}</small>
                    )}
                  </div>
                </div>

                <div className="col-12 col-md-4">
                  <div className="form-group">
                    <label htmlFor="price">Price</label>
                    <input
                      type="number"
                      className="form-control"
                      id="price"
                      name="price"
                      value={secondFormData.price}
                      onChange={handleSecondInputChange}
                    />
                    {errors.price && (
                      <small className="text-danger">{errors.price}</small>
                    )}
                  </div>
                </div>

                <div className="col-12 mt-3">
                  <div className="d-flex justify-content-start gap-3">
                    <button
                      className="btn btn-success"
                      type="submit"
                      style={{
                        borderRadius: "8px",
                        padding: "6px 24px",
                      }}
                      onClick={handleSecondFormSubmit}
                    >
                      Submit
                    </button>

                    <button
                      className="btn btn-dark"
                      type="button"
                      style={{ borderRadius: "8px", padding: "6px 24px" }}
                      onClick={handleCancel}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
          {isSubmitted && (
            <div className="mt-4">
              <div className="mt-4">
                <h5>Variants Data</h5>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th style={{ width: "20%" }}>Attempt</th>
                      <th style={{ width: "20%" }}>SKU</th>
                      <th style={{ width: "20%" }}>Price</th>
                      <th style={{ width: "20%" }}>Edit</th>
                      <th style={{ width: "20%" }}>Cancel</th>
                    </tr>
                  </thead>
                  <tbody>
                    {variants.length > 0 ? (
                      variants.map((variant, index) => (
                        <tr key={index}>
                          <td>
                            {attemptOptions.find(
                              (opt) => opt.id === variant.attempt_id,
                            )?.title || "-"}
                          </td>
                          <td>{variant.sku || "-"}</td>
                          <td>₹{variant.price || 0}</td>
                          <td>
                            <button
                              className="btn btn-warning btn-sm w-75"
                              onClick={() => handleEdit(index)}
                            >
                              Edit
                            </button>
                          </td>
                          <td>
                            <button
                              className="btn btn-danger btn-sm w-75"
                              onClick={() => handleDelete(variant.id)}
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center">
                          No variants added yet.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default UpdateNewCourseMaster;
